import REQUEST_KEY from '@common/constants/requestKeys';
import { ClientError } from '@common/helpers/errors';
import { useHandleAppLoading } from '@common/hooks/appLoading';

// The business BFF router was decommissioned along with je-client. This hook is
// retained as an inert stub so obsolete business UI still compiles; deleting a
// business is no longer wired to a backend.
export const useDeleteBusiness = () => {
  const deleteBusinessMutation = {
    mutate: (_variables?: any) => undefined,
    error: null as any,
    isLoading: false,
    isSuccess: false
  };

  useHandleAppLoading(
    deleteBusinessMutation.isLoading,
    REQUEST_KEY.BUSINESS.DELETE
  );

  return {
    deleteBusiness: deleteBusinessMutation.mutate,
    errorMessage: getClientError(deleteBusinessMutation.error),
    isSuccessful: deleteBusinessMutation.isSuccess
  };
};

const getClientError = (error) => {
  if (!error) return;

  const guid = error?.data?.httpError.guid;
  const responseBody = error?.data;

  return new ClientError('errors.defaultWithGuid', {
    guid,
    responseBody
  });
};
